module.exports = "/_next/static/images/cc259b35082f0e00ffe03fe2735a01fe-wow@0.75x.png";